export default __webpack_public_path__ + "static/media/sy.38189413.svg";